module.exports = __webpack_public_path__ + "static/media/shoulders7.a755c8eb.png";